import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { renderCharmWrapper } from 'owa-calendar-surface-dategrid/lib/surfaceItems/CalendarSurfaceItemComponentRenderer';

/**
 * Renders the charm wrapper for the given month item
 * @param item The item being rendered
 */
export default function RenderCharmWrapperMonthItem(
    item: CalendarEvent,
    colorScheme: ColorScheme,
    charmId: number
) {
    let allDayStyles = require('./CalendarMonthSurfaceItem.scss');
    return renderCharmWrapper(item, colorScheme, charmId, allDayStyles);
}
